import { EventCreatorMap } from '../../models/helpers';

import promoClick from './ee-click';
import promoView from './ee-view';

import { PromoActionsTypes } from '@app/+landing-cms/actions';

const eventsMap: EventCreatorMap = {
  [PromoActionsTypes.PROMO_VIEW]: promoView,
  [PromoActionsTypes.PROMO_CLICKED]: promoClick
};

export default eventsMap;
